import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService, IApiServiceCommand } from '@services/api/api.service';
import { Router } from '../../../../../node_modules/@angular/router';
import { IGridOptions, IColumnOptions, IDataEndPoint } from '@framework/interfaces/IEntity';
import { NbToastrService } from '@nebular/theme';
import { FormBuilderControl } from '../../../common/formbuilder/FormBuilderControl';
import { FormBuilderControlType } from '../../../common/formbuilder/FormBuilderControlType';
import { ViewType } from '../../core/Enums';
import { IButtonAction } from '../mf-blade/mf-blade.component';
import { MfFiltersComponent } from '../mf-filters/mf-filters.component';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';
import * as _ from 'underscore';
import { DialogService } from 'primeng/api';
import { MfColumnSelectorComponent } from '../mf-column-selector/mf-column-selector.component';
import { IControlChangeEventArgs } from '../../../common/formbuilder/IControlChangeEventArgs';
import { SignalRService } from '@services/signalr/signal-rservice.service';
import { MfTableV2Component } from '../mf-table-v2/mf-table-v2.component';
import { BehaviorSubject } from 'rxjs';
import { GroupDescriptor, DataResult, process, State, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { appSettings } from '../../../modules/shared/components/appSettings';

@Component({
  selector: 'mf-list-page',
  templateUrl: './mf-list-page.component.html',
  //styleUrls: ['@framework/components/mf-list-page/mf-list-page.component.css']
})
export class ListPageComponent implements OnInit {
  @ViewChild('assetLazyTable', { static: true }) lazyTable: MfTableV2Component;
  @ViewChild('mfFilters', { static: true }) mfFilters: MfFiltersComponent;
  @ViewChild('test', { static: true }) testDiv: ElementRef<any>;

  public manualFilters: any;
  public get testDivHeight() {
    return this.testDiv.nativeElement.clientHeight
  }
  public splitter: any;
  protected listPageComponentList: IGridOptions;
  protected listPageComponentDetailsRouteUrl: string;
  protected loadOnlyOnEntityId: boolean;
  protected showFilterColOnTable: boolean = true;
  protected _canAdd: boolean = true;
  protected _tableReadonly: boolean = false;
  protected reloadTableOnNotificationReceived: boolean = false;
  protected usev1: boolean = false;
  public instance: any;
  public useV2: boolean = false;

  public get tableReadOnly() { return this._tableReadonly; }
  public formReadonly: boolean;
  private _selectedItem: any;
  private _selectedColumns: any[];
  private _currentFilters: any[];
  public assetPopupVisible: boolean;
	public expandedRowKeys: any;
	public rowCount: any = 50;

  public height: string = "100%";
	public get rows() { return this.list && this.list.rowCount ? this.list.rowCount : this.rowCount; }
  public get rowHeight() { return this.list.rowHeight ? this.list.rowHeight : 36 ; }
  public get disableNavigation() { return this.list.disableNavigation; }
  public get autoExpandRows() { return this.list.autoExpandRows; }
  public get rowGroupMetadataActions() { return this.list.rowGroupMetadataActions; }
  public get grandTotalField() { return this.list.grandTotalField; }
  public get grandTotalFunc() { return this.list.grandTotalFunc; }
  public get groupingField() { return this.list.groupingField; }
  public get groupingSubtotalCalcField() { return this.list.groupingSubtotalCalcField; }
  public get groupingSubtotalCalcFunc() { return this.list.groupingSubtotalCalcFunc; }
  public get header(): string { return this.list.displayName ? this.list.displayName : this.list.model.displayName.split("|")[1] };
  public get list(): IGridOptions { return this.listPageComponentList };
  public get detailsRouteUrl(): string { return this.listPageComponentDetailsRouteUrl };
  public rowGroupMetadata: any;
  public items: any;
  public parent: any;
  public loading: boolean = false;
  public hidden: boolean = false; d
  public staticColumns: any[];
  public columns: any[];
  public advancedFilters: any[] = [];
  public filterActive: boolean = false;
  public listIndex; any;
  public formIndex: number;
  public columnPopupVisible: boolean = false;
  public advancedPopupVisible: boolean = false;
  public filterCount: number; public lookupValues: any;
  public showAdvancedFilters: boolean;
  public staticFilters: any;
  public grandTotal: any;
  private _entityId: any;
  public _menuHidden: boolean = true;
  public get menuHidden() { return this._menuHidden; }
  public set menuHidden(val) {
    var wasHidden = false;
    if (!val && this._menuHidden) wasHidden = true;
    this._menuHidden = val;
    if (wasHidden) {
      this.loadEntity();
    }
  }
  public loadingData: Function;
  public buttonActions: Array<IButtonAction> = new Array();
  public get autoSizeColumns() { return this.list.autoSizeColumns }
  public get tableIsGrouped() { return this.list.tableIsGrouped; }
  public get showFilterCol() { return this.showFilterColOnTable };
  public get loadOnlyOnEntity() { return this.loadOnlyOnEntityId };
  public get entityId() { return this._entityId };
  public set entityId(value) {
    //if (this._entityId == value)
    //  return;
    this.reset();
    this._entityId = value;
    if (value == "00000000-0000-0000-0000-000000000000") {
      this.items = new Array();
      return;
    }
    if (this.list.endPoints.search && this.list.endPoints.search != null)
      this.lazyTable.reloadTable();
    else this.loadItems(null, null);
  }
  public get selectedColumns() { return this._selectedColumns; }
  public set selectedColumns(value) { this._selectedColumns = value; }
  public get selectedItem() { return this._selectedItem; }
  public set selectedItem(value) {
    this._selectedItem = value;
    if (value && value.id) {
      if (this.list && this.list.customSelect) {
        this.list.customSelect(this, value);
        return;
      }
      if (this.detailsRouteUrl)
        this.router.navigate([this.detailsRouteUrl + value.id]);
      if (this.parent && this.parent.navigateToIndex && !this.disableNavigation )
        this.parent.navigateToIndex(this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo ? this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo : this.parent.formIndex + 1, value.id, this.parent.formIndex);
    }

  }
  public afterInitObserver = new BehaviorSubject(null);

  constructor(private apiService: ApiService, private router: Router,
    private messageService: NbToastrService, public authService: IdentityAuthService,
    public dialogService: DialogService, public signalRService: SignalRService) {
    var self = this;

  }

  public reset() {
    this.items = new Array();
    this.formReadonly = false;
    this._menuHidden = false;
  }
  public loadEntity() {
    if (this.menuHidden)
      return;
    if (this.list.endPoints.search && this.list.endPoints.search != null)
      this.lazyTable.reloadTable();
    else this.loadItems(null, null);


  }
  public get canAdd() {
    return this._canAdd && !this.formReadonly;
  }

  public setButtonActions() {
    var self = this;
    this.buttonActions = new Array();
    if (this.canAdd)
      this.buttonActions.push({
        tooltip: 'Add new', click: function () {
          self.addNew()
        }, iconClass: 'nb-plus', text: "Add new"
      });
    if (this.list.endPoints.search) {
      this.buttonActions.push({
        tooltip: 'Advanced column selection', click: function () {
          //self.columnPopupVisible = !self.columnPopupVisible;
          self.showColumnSelectionDialog();
        }, iconClass: 'nb-gear'
      });

      this.buttonActions.push({
        tooltip: 'Advanced filters', click: function () {
          //self.mfFilters.advancedPopupVisible = !self.mfFilters.advancedPopupVisible;
          self.showAdvancedFiltersDialog();
        }, iconClass: 'pi pi-filter'
      });
    }
    if (this.list.endPoints.exportToExcel) {
    var self = this;
      this.buttonActions.push({
        tooltip: 'Export current selection to excel', click: function () {
          //self.addNew()
          debugger;
          var table = self.lazyTable;
          let filterArr = new Array();


          if (table.staticFilters)
            table.staticFilters.filter(function (o) {
              return o.filterValue != '' && o.filterValue != null
            })
              .forEach(o => {
                filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
              });
          let filterObject = JSON.parse(table._currentFilterObject);
          filterObject.StartCount = 0;
          filterObject.PageSize = 9999999;
          filterObject.FriendlyCols = table.selectedVisibleColumns.map(o => ({ value: o.dbField, key: o.name }))

          filterArr.forEach(o => {
            filterObject.Filters.push(o);
          });

          var download: IDataEndPoint = self.list.endPoints.exportToExcel;
          

          self.loading = true;

          self.apiService.exec({
            data: filterObject,
            endPoint: download,
            context: this.list,
            success: function (data) {
              self.messageService.success('Export has started download', 'Action');
              self.loading = false;
              const link = document.createElement('a');
              link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
              link.setAttribute('visibility', 'hidden');
              link.click();
            },
            error: function (error) {
              self.loading = false;
              self.messageService.danger('Could not Export', 'Action');
            }
          })
        }, iconClass: 'fa fa-file-excel'
      });
    }
    if (this.parent && this.parent.setButtonActions)
      this.parent.setButtonActions();
  }
  public ngOnInit() {
    let self: ListPageComponent = this;
    self.setButtonActions();
    this.instance = self;
   
    self.processColumns(self.list.columns, self.list.model.fields);
    var selectedColumns = new Array();
    self.list.columns.forEach(o => {
      selectedColumns.push(o);
    })
    self.staticColumns = self.list.columns;
    if (self.list.endPoints.search && self.list.endPoints.search != null) {
      var newArr = new Array();
      if (self.list.model.nestedPrefix) {
        self.list.model.fields.forEach(f => {
          var exists = self.list.columns.filter(o => o.field == f.name);
          if (exists.length == 0)
            newArr.push({ field: f.name });
        })
        newArr.forEach(o => {
          self.list.columns.push(o);
        })
      }


      self.processColumns(self.list.columns, self.list.model.fields);
      if (self.list.relatedModels) {
        self.list.relatedModels.forEach(mod => {
          var arr = new Array();
          mod.fields.forEach(field => {
            arr.push({ field: field.name });
          });
          self.processColumns(arr, mod.fields);
          arr.forEach(o => {
            o.field = (mod.nestedPrefix ? mod.nestedPrefix : '') + (!mod.excludeModelPrefix ? (mod.name.substring(0, 1).toLowerCase() + mod.name.substring(1)).replace("Model", "") + '.' : '') + o.field;
            //if (!o.dbField)
            o.dbField = o.field.replace(".", "_");
            o.name = mod.name.replace("Model", "") + ' - ' + o.name;
            self.list.columns.push(o);
          });
        });
      }

    }

    self.columns = self.list.columns;
    self.selectedColumns = selectedColumns;
    self.staticFilters = new Array();
    if (this.list.init)
      this.list.init(this)
    if (this.list.staticFilters) {
      this.list.staticFilters.forEach(o => {
        self.staticFilters.push(o);
      });
      this.showAdvancedFilters = true;
    }
    if (this.parent && this.parent.entityIdChange) {
      this.entityId = this.parent.entityId;
      this.parent.entityIdChange.subscribe(entityId => {
        this.entityId = entityId;
      })
    }


    if (self.reloadTableOnNotificationReceived) {
      self.signalRService.newNotification.subscribe(data => {
        self.lazyTable.reloadTable();
      })
    }
  }
  public resize() {
    if (this.lazyTable)
      this.lazyTable.resize();
  }
  public ngAfterViewInit() {
    setTimeout(_ => {
      this.afterInitObserver.next(this.testDivHeight);
    }, 1);

    if (this.list.afterInit)
      this.list.afterInit(this)

  }

  public groupingFunction: Function = function () {
	  var rowGroupMetadata = {};
	  debugger;
    if (this.items) {
      if (!this._dataSortedByGroup)
        this.items = _.sortBy(this.items, this.groupingField);
      else this._sortDataByGroup = this.items;
      this.items.forEach(o => {
        if (!o[this.groupingField])
          o[this.groupingField] = 'Empty';

        this.expandedRowKeys = {};

      })
      for (let i = 0; i < this.items.length; i++) {
        let rowData = this.items[i];
        let brand = rowData[this.groupingField];
        if (i == 0) {
          rowGroupMetadata[brand] = { index: 0, size: 1, rowTotal: 0 };
          if (this.groupingSubtotalCalcField && rowData[this.groupingSubtotalCalcField])
            rowGroupMetadata[brand].rowTotal = rowData[this.groupingSubtotalCalcField];
        }
        else {
          let previousRowData = this.items[i - 1];
          let previousRowGroup = previousRowData[this.groupingField];
          if (brand === previousRowGroup) {
            rowGroupMetadata[brand].size++;
            if (this.groupingSubtotalCalcField && rowData[this.groupingSubtotalCalcField])
              rowGroupMetadata[brand].rowTotal += rowData[this.groupingSubtotalCalcField];
          }
          else {
            rowGroupMetadata[brand] = { index: i, size: 1, groupTotal: 0 };
            if (this.groupingSubtotalCalcField && rowData[this.groupingSubtotalCalcField])
              rowGroupMetadata[brand].rowTotal = rowData[this.groupingSubtotalCalcField];
          }
        }
      }
    }

	  if (this.autoExpandRows) {
		  for (var i in rowGroupMetadata) {
			  if (rowGroupMetadata.hasOwnProperty(i)) {
				  this.expandedRowKeys[i] = false //for new version
				  //this.expandedRowKeys[i] = 1 //old version
			  }
		  }
	  }
	  
    return rowGroupMetadata;
  }

  loadItems(filterObject, selectedItem?) {
    if (this.menuHidden)
      return;
    if ((typeof this.loadOnlyOnEntity == 'undefined' || this.loadOnlyOnEntity) && !this.entityId)
      return;
    if (this.manualFilters) {
      filterObject.manualFilters = this.manualFilters;
    }
    let self: ListPageComponent = this;
    if (self.list.endPoints.search && self.list.endPoints.search != null) {
      this.loading = true;
      if (this.loadingData)
        this.loadingData(true, null)
      self.apiService.exec({
        data: filterObject,
        endPoint: self.list.endPoints.search,
        context: self,
        success: function (data) {
          self.resetLookupValueProcessed();

          if (self.tableIsGrouped)
            self.items = process(data, { group: this.groups });
          else self.items = data;
          if (selectedItem) self.selectedItem = selectedItem; self.loading = false;
          self.processLookupValues();
          // if (self.tableIsGrouped)
          //self.rowGroupMetadata = self.groupingFunction(self.items);
          if (self.parent.buildMenus)
            self.parent.buildMenus(self.items, false, self.listIndex, self)
          self.calcGrandTotal();

          if (self.loadingData)
            self.loadingData(false, self.items)
        },
        error: function (error) {
          self.loading = false;
          self.messageService.danger('Could not load page filter', 'Action');
          if (self.loadingData)
            self.loadingData(false, null)
        }
      })

      self.apiService.exec({
        data: filterObject,
        endPoint: self.list.endPoints.pagingTotalCount,
        context: self,
        success: function (data) {
          self.filterCount = data;
        },
        error: function (error) {
        }
      })
    }
    else if (self.list.dataEndPoint) {
      self.loading = true; self.filterCount = 99999;
      if (this.loadingData)
        this.loadingData(true, null)
      self.apiService.exec({
        endPoint: self.list.dataEndPoint,
        context: self,
        success: function (data) {
          self.resetLookupValueProcessed();
          self.items = data; if (selectedItem) self.selectedItem = selectedItem; self.loading = false;
          self.processLookupValues();
          //if (self.tableIsGrouped)
          //self.rowGroupMetadata = self.groupingFunction(self.items);
          if (self.loadingData)
            self.loadingData(false, self.items)
        },
        error: function (error) {
          self.loading = false;
          self.messageService.danger('Could not load', 'Action');
          if (self.loadingData)
            self.loadingData(false, null)
        }
      })
    }
  }

  resetLookupValueProcessed() {
    if (this.lookupValues)
      this.lookupValues.forEach(o => {
        o.processed = false;
      });
  }


  private processColumns(columns: Array<IColumnOptions>, fields: any) {
    this.lookupValues = new Array();
    this.lazyTable.defaultFilters.filters = [];
    columns.forEach(o => {
		if (o.default) {
        this.lazyTable.defaultFilters.filters.push({ operator: "eq", field: o.dbField, value: o.default })

        //if (!this.lazyTable.state.filter)
        //  this.lazyTable.state.filter = { logic: "and", filters: [{ operator: "eq", field: o.dbField, value: o.default }] };
        //else this.lazyTable.state.filter.filters.push({ operator: "eq", field: o.dbField, value: o.default });
        this.lazyTable.cdr.detectChanges();
        //this.lazyTable.filters[o.dbField] = o.default;
        //if (this.lazyTable.dt)
        //  this.lazyTable.dt.filters[o.dbField] = { value: o.default };
        //debugger;

        //this.state.filter.filters
      }
      if (fields[o.field]) {

        if (!o.name) o.name = fields[o.field].displayName;
        if (!o.fieldType) o.fieldType = fields[o.field].fieldType;
      }
      if (typeof o.readOnly === "undefined") o.readOnly = true;
      if (!o.filterMatchMode) o.filterMatchMode = 'contains';
      if (!o.dbField)
        o.dbField = o.field;

      if (o.dataEndPoint && o.dataEndPoint.url)
        this.apiService.get(o.dataEndPoint.url).subscribe(items => {
          this.lookupValues.push({
            field: o.field,
            values: items.map(lo => {
              return { id: lo[o.dataIdField], display: lo[o.dataDisplayField] }
            }),
            processed: false
          })
          this.processLookupValues();
        })


      if (!o.formBuilderControl) {
        let control = new FormBuilderControl();
        control.controlType = new FormBuilderControlType(typeof o.fieldType != 'undefined' ? o.fieldType : o.fieldType, null);

        if (o.viewType) {
          control.controlType.viewType = o.viewType;
        }

        control.displayName = o.name;
        control.bindingValue = o.field;
        control.field = o.field;
        control.fieldOptions = o;
        o.formBuilderControl = control;
      }
      else {
        o.formBuilderControl.fieldOptions = o;
      }

      if (o.formBuilderControl.controlType.viewType == ViewType.CheckBox) o.filterMatchMode = 'equals';
      o.whereFilterType = 1;
    })
  }

  processLookupValues() {
    var self = this;
    if (self.lookupValues && self.items && self.items.length > 0) {
      self.lookupValues.filter(o => !o.processed).forEach(lo => {
        self.items.forEach(i => {
          var lookup = lo.values.filter(z => z.id == i[lo.field]);
          if (lookup.length > 0)
            i[lo.field] = lookup[0].display;
        });
        lo.processed = true;
      })
    }
  }

  public advancedFilterSearch() {
    this.advancedFilters.forEach(item => {
      this.lazyTable.dt.filter(item.filter, item.field.filterName, 'contains');
    })
  }
  public clearAdvancedFilter() {
    this.advancedFilters = [];
    this.lazyTable.dt.reset();

  }

  public onControlDataChange(event: IControlChangeEventArgs) {
    let self = this;
    debugger;
    let col = this.columns.filter(function (o) {
      return o.field == event.formBuilderControl.field || o.dbField == event.formBuilderControl.field
    })[0];

    

    if (col.endPoints) {
      if (event.formBuilderControl.controlType.viewType == ViewType.CheckBox) {
        let endPoint: IDataEndPoint = (col.endPoints.insert && event.controlValue) ? col.endPoints.insert : (col.endPoints.delete && !event.controlValue) ? col.endPoints.delete : null;
        if (endPoint) {
          self.loading = true;
          self.apiService.exec({
            endPoint: endPoint,
            data: event.extraData,
            context: self,
            success: function (data) {
              self.loading = false;
              self.messageService.success('Successfully saved', 'Action');
              if (self.parent && self.parent.onBladeSave)
                self.parent.onBladeSave(self);
              if (self.parent && self.parent.updateLists)
                self.parent.updateLists();
            },
            error: function (error) {
              self.loading = false;
              self.messageService.danger('Could not save', 'Action');
            }
          })
        }
      }

      if (event.formBuilderControl.controlType.viewType == ViewType.StatusChange) {
        let endPoint: IDataEndPoint = col.endPoints.update;
        if (endPoint) {
          self.loading = true;
          self.apiService.exec({
            endPoint: endPoint,
            data: event.extraData,
            context: self,
            success: function (data) {
              self.loading = false;
              self.messageService.success('Successfully saved', 'Action');
              if (self.parent && self.parent.onBladeSave)
                self.parent.onBladeSave(self);
              if (self.parent && self.parent.updateLists)
                self.parent.updateLists();
            },
            error: function (error) {
              self.loading = false;
              self.messageService.danger('Could not save', 'Action');
            }
          })
        }
      }
    }
  }

  onAdvancedFilterSearch(filters) {
    this.lazyTable.reloadTable();
  }

  onPageEvent() {
    this.splitter.nativeElement.scrollTo({ top: (0), behavior: 'smooth' });
  }

  public addNew() {
    if (this.parent && this.parent.navigateToIndex)
      this.parent.navigateToIndex(this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo ? this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo : this.parent.formIndex + 1,
        "00000000-0000-0000-0000-000000000000", this.parent.formIndex);
  }

  public makeFormReadOnly(readonly) {
    this.formReadonly = readonly;
    this.setButtonActions();
  }

  public calcGrandTotal() {
    if (this.grandTotalFunc) {
      this.grandTotal = this.grandTotalFunc(this.items.data);
      return;
    }

    if (!this.grandTotalField) {
      this.grandTotal = undefined;
      return;
    }
    var total = 0;
    this.items.data.forEach(o => {
      if (o[this.grandTotalField])
        total += o[this.grandTotalField]
    });
    this.grandTotal = total.toLocaleString();
  }


  public showColumnSelectionDialog() {
    const ref = this.dialogService.open(MfColumnSelectorComponent, {
      data: {
        staticColumns: this.staticColumns,
        loading: this.loading,
        columns: this.columns,
        selectedColumns: this.selectedColumns
      },
      header: 'Select columns',
      width: '50%'
    });
    ref.onClose.subscribe((selectedColumns) => {
      if (selectedColumns) {
        this.selectedColumns = selectedColumns;
      }
    });
  }

  public showAdvancedFiltersDialog() {
    var self = this;
    const ref = this.dialogService.open(MfFiltersComponent, {
      data: {
        filters: self.staticFilters,
        columns: self.columns,
        showAdvancedFilters: self.showAdvancedFilters
      },
      header: 'Advanced filters',
      width: '50%'
    });
    ref.onClose.subscribe((staticFilters) => {
      if (staticFilters) {
        this.staticFilters = staticFilters;
        this.lazyTable.reloadTable();
      }
    });
  }
}
